export const inputValidators = {

    methods: {

        validateDisplayNameCharInput(event) {
            this.form.display_name = this.form.display_name.replace('"', '');
        },

        validateDisplayDescriptionCharInput(event) {
            this.form.display_description = this.form.display_description.replace('"', '');
        }

    }

}
